var e={onClick:e=>{e.resolve()},enableStoreDetails:!1,storePaymentMethod:!1};export{e as default};
//# sourceMappingURL=defaultProps.js.map
